import React from 'react';

import { CSSProp } from 'styled-components';

import Footer, { ClearButton, SelectedCount } from '@adsk/alloy-react-footer';

import { FooterProps } from '../../types';

/**
 * pointer-events prevents the menu from closing when clicking disabled clear button.
 * pointer-events disables the not-allowed cursor, so we put it on a parent element.
 */
const disableStyle: {
  parent: CSSProp;
  child: CSSProp;
} = {
  parent: {
    cursor: 'not-allowed',
  },
  child: {
    pointerEvents: 'none',
  },
};

export const DefaultFooter = ({
  selectedItems,
  onClear,
  onBlur,
  disableClear,
  ...props
}: FooterProps) => (
  <Footer {...props}>
    {selectedItems && <SelectedCount count={selectedItems.length} />}

    <div css={disableClear ? disableStyle.parent : undefined}>
      <ClearButton
        style={disableClear ? disableStyle.child : undefined}
        disabled={disableClear}
        onBlur={onBlur}
        onClick={onClear}
        onMouseDown={(e) => {
          // Prevent the input from losing focus when the clear button is clicked
          e.preventDefault();
        }}
      />
    </div>
  </Footer>
);
